import { render } from "./LocationPage.vue?vue&type=template&id=ed20c4e8"
import script from "./LocationPage.vue?vue&type=script&lang=js"
export * from "./LocationPage.vue?vue&type=script&lang=js"

import exportComponent from "/home/fluffypony/Projects/tai-g-damn/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__